import React from 'react';
import classes from '../../utils/cssClasses';


const  renderTextField = (field) => {
	const classGroup = `form-group  ${ field.meta.touched  && field.meta.error ? 'has-danger' : ''} ${ field.type === 'hidden' ? 'd-none' : ''}`
	return (
		<div className={classes(classGroup)}>
			<label>{field.label} { field.required ?  '*' : '' }</label>
			{ field.type === 'textarea' ? (
				<textarea
				rows="5"
				className={classes('form-control')}
				type={field.type}
				{...field.input} />
			): ( 
				<input
					className={classes('form-control')}
					type={field.type}
					{...field.input} />
				)
		}
			{
				field.meta.touched ? (
				<div className={classes("invalid-feedback d-block")}>
					{ field.meta.error }
				</div>
				) : ''
			}
		</div>
	);
}

const  renderChoiceField = (field) => {
	const classGroup = `form-check  ${ field.meta.touched  && field.meta.error ? 'has-danger' : ''} ${ field.type === 'hidden' ? 'd-none' : ''}`
	return (
		<div className={classes(classGroup)}>
			<input
				className={classes('form-check-input')}
				type={field.type}
				id={field.id}
				{...field.input} />
			<label htmlFor={field.id} className={classes('form-check-label')}>{field.label} { field.required ?  '*' : '' }</label>
			{
				field.meta.touched ? (
					<div className={classes("invalid-feedback d-block")}>
						{ field.meta.error }
					</div>
				) : ''
			}
		</div>
	);
}
export default function(field) {
		// const { meta : {touched, error } } = field;
	if (field.type === 'checkbox'){
		return renderChoiceField(field);
	}
	return renderTextField(field);		
}


// WEBPACK FOOTER //
// ./src/components/Backend/RenderField.js